import { useMutation, UseMutationOptions } from "@tanstack/react-query"

import { UpdateIdentifyCardProfile, updateIdentifyCardProfile } from "@/api"
import { SchemaResponse } from "@/modules/types/common/schema"

const useIdentifyCard = (
  options: UseMutationOptions<SchemaResponse<null>, Error, UpdateIdentifyCardProfile> = {}
) => {
  return useMutation<SchemaResponse<null>, Error, UpdateIdentifyCardProfile>({
    mutationFn: async (data: UpdateIdentifyCardProfile) => {
      const response = await updateIdentifyCardProfile(data)
      return response.data
    },
    ...options  
  })
}

export default useIdentifyCard
